(function () {
    'use strict';

    angular
        .module('controlModule')
        .controller('grcControlTestTestingInfosController', Controller);

    Controller.$inject = ['$rootScope', '$scope', 'commonAricService'];

    function Controller($rootScope, $scope, commonAricService) {

        // When assessment
        if ($scope.boxModel.ControlAssessment && $scope.boxModel.ControlAssessment.IsTesting) {
            commonAricService
                .getControlTestingInfos($scope.boxModel.ControlID)
                .then(function (controlTestingInfos) {
                    $scope.controlTestingInfos = controlTestingInfos;
                });
        }
    }
})();